import { useEffect, useRef } from 'react';

function useDebounceCallback(dependency, callback, delay = 500, options = {}) {
  const ref = useRef(false);

  useEffect(() => {
    if (!ref.current && options.skipFirstRender) {
      ref.current = true;
      return;
    }

    const timer = setTimeout(() => callback(), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [dependency, delay]);

  return null;
}

export default useDebounceCallback;
